import React, { Component } from 'react';
import config from 'react-global-configuration';
// Importação do Router
import { Link } from 'react-router-dom';
import Select from 'react-select';
// Importação da tabela
import RequestApi from '../Miscelania/RequestApi';

import Overlay from '../Miscelania/Overlay';


class EmailTrainingAttendenceConfirmation extends Component {

  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'open',
      },
      redirect_url: false,
      abscence: false,
      deslocation: false,
      loaded: 0,
      message: '',
      justification: '',
      deslocation_type: 1,
    };
    // Handlers
    this.handleAlert = this.handleAlert.bind(this);

    this.loadData = this.loadData.bind(this);
    this.add = this.add.bind(this);
    this.deslocationType = this.deslocationType.bind(this);
  }
  // Handlers
  handleChange (name, event) {
    var change = {};
    change[name] = event.target.value;
    this.setState(change);
  }

  // Handlers
  handleSelectChange(name, event) {
    var change = {};
    if(event == null) {
      change[name] = null;
    } else {
      change[name] = event.value;
    }
    this.setState(change);
  }


  handleAlert(message, type, status, mode) {
    if(mode === 'reset') {
      this.setState({overlay: {message: '', type: '', status: 'closed'}});
    } else {
      this.setState({overlay: {message: message, type: type, status: status}});
    }
  }

  componentDidMount() {
    this.loadData();
  }

  loadData() {
    var self = this;
    var datasave = {
      token: this.props.match.params.token,
    };

    var headers = {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
    };
    fetch(config.get('api') + '/email/confirmacao', { method: 'POST', mode: 'cors', headers: headers, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
      self.setState({overlay: {message: '', type: '', status: 'closed'}, message: responseJson.message});
      if (responseJson.data === "absence") {
        self.setState({abscence: true});
      } 
      if (responseJson.data === 'deslocation') {
        self.setState({deslocation: true});
      }
      self.handleAlert('', '', 'closed', 'reset');
    }).catch((error) => {
      console.error(error);
    });
  }

  add(event) {
    event.preventDefault();
    this.setState({overlay: {message: '', type: '', status: 'open'}});
    var datasave = {
      token: this.props.match.params.token,
      justification: this.state.justification,
    };

    var headers = {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
    };
    fetch(config.get('api') + '/email/confirmacao/justificativa', { method: 'POST', mode: 'cors', headers: headers, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
      this.setState({overlay: {message: '', type: '', status: 'closed'}, message: responseJson.message});
        this.setState({abscence: false});
      this.handleAlert('', '', 'closed', 'reset');
    }).catch((error) => {
      console.error(error);
    });
  }

  deslocationType(event) {
    event.preventDefault();
    var self = this;
    this.setState({overlay: {message: '', type: '', status: 'open'}});
    var datasave = {
      deslocation_type: this.state.deslocation_type,
      token: this.props.match.params.token,
      force_change: 1,
    };
    var headers = {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
    };
    fetch(config.get('api') + '/email/confirmacao', { method: 'POST', mode: 'cors', headers: headers, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
      self.setState({overlay: {message: '', type: '', status: 'closed'}, message: 'Presença confirmada com sucesso.', deslocation: false});
      self.handleAlert('', '', 'closed', 'reset');
    }).catch((error) => {
      console.error(error);
    });
  }

  render() {
    return (
<div className="user-wrapper" style={{backgroundImage: "url('" + config.get('cdn') + "/images/modal_background.png'), url('" + config.get('cdn') + "/images/fundo-login.jpg')"}}>
  <Overlay overlay={this.state.overlay} handleAlert={this.handleAlert} />
  <div className="user-layer-suspended">
    <div className="container">
      <div className="row">
  			<div className="col-md-4 col-md-offset-4">
          {this.state.abscence === true ?
            <div className="user-content text-center">
              <img src={config.get('cdn') + '/images/logo2.png'} alt="SIGMEC" />
              <h3>Justifique a ausencia</h3>
              <br/>
              <form onSubmit={this.add}>
                <div className="form-group">
                  <textarea style={{ height: 100 }} type="text" name="justification" className="form-control" value={this.state.justification} onChange={this.handleChange.bind(this, 'justification')} required />
                </div>
                <div className="form-group">
                  <button type={'submit'} className="btn btn-primary btn-inline btn-block"><i className="fa fa-fw fa-save"></i> Justificar</button>
                </div>
              </form>
            </div>
          : this.state.deslocation === true ?
            <div className="user-content text-center">
              <img src={config.get('cdn') + '/images/logo2.png'} alt="SIGMEC" />
              <h3>{this.state.message}</h3>
              <br/>
              <form onSubmit={this.deslocationType}>
                <div className="row">
                  <div className="col-md-12 form-group">
                    <Select
                      className="form-field-name"
                      name="deslocation_type"
                      value={this.state.deslocation_type}
                      searchable={true}
                      placeholder={'Selecionar meio de transporte'}
                      onChange={this.handleSelectChange.bind(this, 'deslocation_type')}
                      options={[
                        {value: 1, label: 'Sim'},
                        {value: 2, label: 'Não'},
                      ]}
                      required
                    />
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-12 form-group">
                    <button type={'submit'} className="btn btn-primary btn-block"><i className="fa fa-fw fa-save"></i> Enviar resposta</button>
                  </div>
                </div>
              </form>
            </div>
          :
          <div className="user-content text-center">
            <img src={config.get('cdn') + '/images/logo2.png'} alt="SIGMEC" />
            <h3>{this.state.message}</h3>
            <br/>
            <p>
              <Link className={'btn btn-success'} to='/usuario/login'>
                <i className="fa fa-fw fa-refresh"></i> Recarregar
              </Link>
            </p>
          </div>
          }
  			</div>
      </div>
		</div>
  </div>
</div>
    );
  }
}

export default EmailTrainingAttendenceConfirmation;



// WEBPACK FOOTER //
// ./src/Components/Users/EmailTrainingAttendenceConfirmation.js